import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 41,
    s: 46
  });
  const spotsTaken = 94;
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = Math.max(0, current.h * 3600 + current.m * 60 + current.s - 1);
        return {
          h: Math.floor(seconds / 3600),
          m: Math.floor(seconds % 3600 / 60),
          s: seconds % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => value.toString().padStart(2, '0');
  const time = `${format(timeLeft.h)}:${format(timeLeft.m)}:${format(timeLeft.s)}`;
  return <div className="sticky top-0 z-50 w-full border-b border-brand-gold/40 bg-brand-greenDeep text-brand-cream shadow-md" data-id="element-293" data-mp="1bw6mrju4zcso">
      <div className="mx-auto max-w-7xl px-3 py-2.5 md:px-6" data-id="element-294" data-mp="1gurm7h1kdsg2">
        <div className="hidden items-center justify-center gap-5 text-sm font-medium md:flex" data-id="element-295" data-mp="27ezrjipoxrv3">
          <div className="flex items-center gap-2 text-brand-goldLight" data-id="element-296" data-mp="22nq48orm70md">
            <ClockIcon className="h-4 w-4" data-id="element-297" data-mp="1xowqcv8f17lo" />
            <span data-id="element-298" data-mp="1xpomc75xd7ch">PRECIO DE LANZAMIENTO CIERRA EN:</span>
            <span className="rounded bg-white/15 px-2 py-0.5 font-mono font-bold tabular-nums text-white" data-id="element-299" data-mp="1sptsbuqus1n7">{time}</span>
          </div>
          <span className="h-4 w-px bg-white/25" data-id="element-300" data-mp="2qcj5n0r0a0od" />
          <span data-id="element-301" data-mp="2qb7zwve02ium">
            <strong className="text-brand-amber" data-id="element-302" data-mp="2ler219h00q4c">{spotsTaken}%</strong> de cupos tomados
          </span>
          <a href="#comprar" className="rounded-full bg-brand-amber px-3 py-1 text-xs font-bold text-brand-greenDeep transition-colors duration-150 ease-out hover:bg-brand-goldLight" data-id="element-303" data-mp="2gev8k45xgh31">
            VER PACK →
          </a>
        </div>
        <div className="relative overflow-hidden md:hidden" data-id="element-304" data-mp="1510u1rmrdhpf">
          <motion.div className="flex w-max items-center gap-5 whitespace-nowrap text-[11px] font-semibold" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 16,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-305" data-mp="10yw71bqtfjbr">
            {[0, 1].map(item => <React.Fragment key={item} data-id="element-306" data-mp="shnfv5mpicpz">
                <span data-id="element-307" data-mp="sglt43wbw1sf">
                  ⏰ Cierra en <strong data-id="element-308" data-mp="sjq3xk4atvs2">{time}</strong>
                </span>
                <span data-id="element-309" data-mp="xfp03tvvci31">•</span>
                <span data-id="element-310" data-mp="xevpuixpbag5">
                  <strong className="text-brand-amber" data-id="element-311" data-mp="jpbpfjrlepa0">{spotsTaken}%</strong> de cupos tomados
                </span>
                <a href="#comprar" className="rounded-full bg-brand-amber px-2.5 py-1 text-brand-greenDeep" data-id="element-312" data-mp="ofs6reyjav1n">
                  VER PACK →
                </a>
              </React.Fragment>)}
          </motion.div>
        </div>
      </div>
    </div>;
}